/**
 * お知らせの受信箱 — server-side list + read state (githubDOCS/TASKS/2026-10-18_お知らせの受信箱と送信履歴.md).
 * The notice in Firestore is the source of truth; the push only points at it.
 */
import { apiFetch } from './authApi';
import { getApiBaseUrl } from './apiBase';

const API = getApiBaseUrl();

async function call(path, options = {}) {
  const res = await apiFetch(`${API}${path}`, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || `${res.status} ${res.statusText}`);
  return data;
}

/** @returns {Promise<{items: Array, unseenCount: number, seenAt: string}>} */
export function fetchAnnouncements() {
  return call('/announcements');
}

/** The inbox was opened: badge and home popup go away. `upTo` = newest publishedAt shown. */
export function markAnnouncementsSeen(upTo) {
  return call('/announcements/seen', { method: 'PATCH', body: JSON.stringify({ upTo: upTo || null }) });
}

export function markAnnouncementRead(id) {
  return call(`/announcements/${encodeURIComponent(id)}/read`, { method: 'PATCH' });
}

/** dev only */
export function editAnnouncement(id, { title, body }) {
  return call(`/announcements/${encodeURIComponent(id)}`, { method: 'PATCH', body: JSON.stringify({ title, body }) });
}

/** dev only (soft delete) */
export function deleteAnnouncement(id) {
  return call(`/announcements/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

// One fetch per page load for the badge + popup, shared by every caller.
let summaryPromise = null;
export function fetchAnnouncementsSummary({ force = false } = {}) {
  if (force || !summaryPromise) {
    summaryPromise = fetchAnnouncements().catch(() => ({ items: [], unseenCount: 0, seenAt: '' }));
  }
  return summaryPromise;
}
export function invalidateAnnouncementsSummary() {
  summaryPromise = null;
}
